<script>
  import Layout from "@/layouts/main.vue";
  import PageHeader from "@/components/page-header";

  import RoomDetailForm from './Part/RoomDetailCanvas.vue';

  export default {
    components: {
      Layout,
      PageHeader,

      RoomDetailForm
    },
    data() {
      return {
        data: {},
        stuff: [],
      };
    },
    mounted() {
      var vm = this;

      vm.load();
    },
    methods: {
      load() {
        var vm = this;

        vm.create();
      },
      newData() {
        var vm = this;

        var data = {
          id: null,
          status_id: null,
          user_id: null,
          room_id: null,
          stuff_id: null,
          ref_no: null,
          booked_at: null,
          expired_at: null,
          signin_at: null,
          signout_at: null
        };

        vm.data = Object.assign({}, data);
      },
      async create() {
        var vm = this;

        this.$loading.on('reservation_detail_create');
        try {
          vm.newData();

          var resp = await this.$api.Reservation.get(vm.$route.params.id);
          var data = resp.data.data;

          vm.data = data;

          vm.fetchStuff();

          this.$loading.off('reservation_detail_create');
        } catch (err) {
          this.$flash.error(err.response.data.message);
        }
      },
      async fetchStuff() {
        var vm = this;

        this.$loading.on('reservation_detail_stuff_create');

        try {
          var params = {
            page: 'all',
            room_id: vm.data.room_id
          };

          var resp = await this.$api.Stuff.all(params);

          var data = resp.data.data;

          this.stuff = data;

          this.$loading.off('reservation_detail_stuff_create');
        } catch (err) {
          // console.log(err.response.data.message) 
        }
      },
      async setStatus(params) {
        var vm = this;
        this.$loading.on(['reservation_detail_status', params.id].join('_'));

        try {
          var resp = await this.$api.Reservation.status(params);
          var data = resp.data;

          vm.create();

          this.$flash.success(data.message);
        } catch (err) {
          this.$flash.error(err.response.data.message);
        }
        this.$loading.off(['reservation_detail_status', params.id].join('_'));
      },
      accept(id) {
        this.setStatus({ id: id, status: 'approved' });
      },
      reject(id) {
        this.setStatus({ id: id, status: 'reject' });
      },
      cancel(id) {
        this.setStatus({ id: id, status: 'cancel' });
      },
      signin(id, ref_no = null) {
        this.setStatus({ id: id, ref_no: ref_no, status: 'going' });
      },
      signout(id) {
        this.setStatus({ id: id, status: 'done' });
      },
    }
  };
</script>

<template>
  <Layout>
    <PageHeader :title="$t('reservation.title.detail')" :pageTitle="$t('menu.sub_header.dashboard')" />
    <BRow>
      <BCol lg="12">
        <BCard no-body class="mt-n4 mx-n4 ribbon-box right">
          <div :class="{
            'bg-light-subtle': data.status_name == 'draft',
            'bg-warning-subtle': data.status_name == 'pending',
            'bg-success-subtle': data.status_name == 'approved',
            'bg-info-subtle': data.status_name == 'going',
            'bg-dark-subtle': data.status_name == 'done',
            'bg-danger-subtle': data.status_name == 'reject',
            'bg-danger-subtle': data.status_name == 'cancel',
            'bg-danger-subtle': data.status_name == 'expired',
          }">
            <BCardBody class="pb-0 px-4">
              <div v-if="data.status_name == 'draft'" class="ribbon-three ribbon-three-light"><span class="text-dark">{{
                data.status }}</span></div>
              <div v-if="data.status_name == 'pending'" class="ribbon-three ribbon-three-warning"><span>{{
                data.status }}</span></div>
              <div v-if="data.status_name == 'approved'" class="ribbon-three ribbon-three-success"><span>{{
                data.status }}</span></div>
              <div v-if="data.status_name == 'going'" class="ribbon-three ribbon-three-info"><span>{{
                data.status }}</span></div>
              <div v-if="data.status_name == 'done'" class="ribbon-three ribbon-three-dark"><span>{{
                data.status }}</span></div>
              <div v-if="data.status_name == 'reject'" class="ribbon-three ribbon-three-danger"><span>{{
                data.status }}</span></div>
              <div v-if="data.status_name == 'cancel'" class="ribbon-three ribbon-three-danger"><span>{{
                data.status }}</span></div>
              <div v-if="data.status_name == 'expired'" class="ribbon-three ribbon-three-danger"><span>{{
                data.status }}</span></div>
              <BRow class="mb-3">
                <BCol md>
                  <BRow class="align-items-center g-3">
                    <BCol md="auto">
                      <!-- <div class="avatar-lg">
                        <div class="avatar-title bg-white rounded-circle">
                          <img src="@/assets/images/cafeman/store.svg" alt="" class="avatar-md">
                        </div>
                      </div> -->
                      <div class="d-flex justify-content-center mb-3 mt-3">
                        <div class="avatar-lg">
                          <div
                            class="avatar-title bg-light text-dark rounded-circle d-flex align-items-center justify-content-center">
                            <i class="mdi mdi-storefront-outline" style="font-size: 50px;"></i>
                          </div>
                        </div>
                      </div>
                    </BCol>
                    <BCol md>
                      <div class="mb-3">
                        <skeleton :loading="$loading.get('reservation_detail_create')" :schema="['col-2', 'col-1']">
                          <h4 class="fw-bold mb-0">{{ data.store }}</h4>
                          <h6 class="text-body-secondary">{{ data.store_ref_no }}</h6>
                        </skeleton>
                      </div>
                      <skeleton :loading="$loading.get('reservation_detail_create')" :schema="['col-3', 'col-6']">
                        <div class="d-flex align-items-center">
                          <i class="mdi mdi-store-outline me-2 fs-4"></i>
                          <div class="d-flex flex-column">
                            <span>{{ data.branch_ref_no }} | {{ data.branch }}</span>
                          </div>
                        </div>
                        <div class="d-flex align-items-center">
                          <i class="mdi mdi-map-marker fs-4 me-2"></i>
                          <div class="d-flex flex-column">
                            <span>{{ data.address }}</span>
                          </div>
                        </div>
                      </skeleton>
                    </BCol>
                  </BRow>
                </BCol>
              </BRow>
            </BCardBody>
          </div>
        </BCard>
      </BCol>
    </BRow>
    <BRow>
      <BCol xl="3">
        <BCard no-body>
          <BCardBody>
            <skeleton :loading="$loading.get('reservation_detail_create')" :schema="['col-6', 'col-12']">
              <ul class="list-unstyled mb-0 vstack gap-3">
                <li>
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 avatar-sm">
                          <div class="avatar-title rounded bg-light text-dark">
                            <i class="mdi mdi-account-outline fs-1"></i>
                          </div>
                        </div>
                        <div class="flex-shrink-0 ms-3 d-flex flex-column">
                          <strong class="mb-0">{{ data.user_name }}</strong>
                          <span>{{ data.user_phone }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </skeleton>
          </BCardBody>
        </BCard>
        <BCard no-body>
          <BCardBody>
            <div class="mb-3">
              <div class="table-responsive table-card position-relative mb-0 p-2">
                <table class="table table-sm">
                  <tbody>
                    <tr>
                      <td class="align-middle pt-2 pb-2" style="width: 150px;">
                        <skeleton :loading="$loading.get('reservation_detail_create')" :schema="['col-12']">
                          <strong>{{ $t('reservation.label.ref_no') }}</strong>
                        </skeleton>
                      </td>
                      <td class="align-middle pt-2 pb-2">
                        <skeleton :loading="$loading.get('reservation_detail_create')" :schema="['col-12']">
                          {{ data.ref_no }}
                        </skeleton>
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle pt-2 pb-2">
                        <skeleton :loading="$loading.get('reservation_detail_create')" :schema="['col-12']">
                          <strong>{{ $t('reservation.label.room') }}</strong>
                        </skeleton>
                      </td>
                      <td class="align-middle pt-2 pb-2">
                        <skeleton :loading="$loading.get('reservation_detail_create')" :schema="['col-12', 'col-6']">
                          {{ data.room }}
                          <br><span class="text-body-secondary">{{ data.room_ref_no }}</span>
                        </skeleton>
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle pt-2 pb-2">
                        <skeleton :loading="$loading.get('reservation_detail_create')" :schema="['col-12']">
                          <strong>{{ $t('reservation.label.stuff') }}</strong>
                        </skeleton>
                      </td>
                      <td class="align-middle pt-2 pb-2">
                        <skeleton :loading="$loading.get('reservation_detail_create')" :schema="['col-12', 'col-6']">
                          <strong>{{ data.stuff }}</strong> | <span>{{ data.stuff_qty }} {{ $t('basic.label.person')
                          }}</span>
                          <br><span class="text-body-secondary">{{ data.stuff_ref_no }}</span>
                        </skeleton>
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle pt-2 pb-2">
                        <skeleton :loading="$loading.get('reservation_detail_create')" :schema="['col-12']">
                          <strong>{{ $t('reservation.label.booked') }}</strong>
                        </skeleton>
                      </td>
                      <td class="align-middle pt-2 pb-2">
                        <skeleton :loading="$loading.get('reservation_detail_create')" :schema="['col-6', 'col-6']">
                          <span>{{ $dateFormat.id(data.booked_at) }}</span><br>
                          <strong>{{ $dateFormat.idTime(data.booked_at) }} - {{ $dateFormat.idTime(data.finish_at)
                          }}</strong>
                        </skeleton>
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle pt-2 pb-2">
                        <skeleton :loading="$loading.get('reservation_detail_create')" :schema="['col-12']">
                          <strong>{{ $t('reservation.label.expired') }}</strong>
                        </skeleton>
                      </td>
                      <td class="align-middle pt-2 pb-2">
                        <skeleton :loading="$loading.get('reservation_detail_create')" :schema="['col-12']">
                          <BBadge variant="danger">{{ $dateFormat.datetime(data.expired_at) }}</BBadge>
                        </skeleton>
                      </td>
                    </tr>
                    <tr v-if="data.sigin_at">
                      <td class="align-middle pt-2 pb-2">
                        <skeleton :loading="$loading.get('reservation_detail_create')" :schema="['col-12']">
                          <strong>{{ $t('reservation.label.signin') }}</strong>
                        </skeleton>
                      </td>
                      <td class="align-middle pt-2 pb-2">
                        <skeleton :loading="$loading.get('reservation_detail_create')" :schema="['col-12']">
                          {{ $dateFormat.datetime(data.sigin_at) }}
                        </skeleton>
                      </td>
                    </tr>
                    <tr v-if="data.signout_at">
                      <td class="align-middle pt-2 pb-2">
                        <skeleton :loading="$loading.get('reservation_detail_create')" :schema="['col-12']">
                          <strong>{{ $t('reservation.label.signout') }}</strong>
                        </skeleton>
                      </td>
                      <td class="align-middle pt-2 pb-2">
                        <skeleton :loading="$loading.get('reservation_detail_create')" :schema="['col-12']">
                          {{ $dateFormat.datetime(data.signout_at) }}
                        </skeleton>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="text-center">
                <div>
                  <img :src="data.qr" class="img-fluid" />
                </div>
                <skeleton :loading="$loading.get('reservation_detail_create')" :schema="['col-4', 'col-10', 'col-3']">
                  <p class="mb-0">{{ data.ref_no }}</p>
                  <p class="text-muted mb-0">{{ $t('reservation.notes.qr') }}</p>
                </skeleton>
              </div>
            </div>
            <div class="d-grid gap-2">
              <BButton type="button" variant="warning" id="edit-btn"
                :to="{ name: 'reservation-update', params: { id: data.id } }"
                :disabled="$loading.get('reservation_detail_create')"
                v-if="($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_create') && ($ac.hasAccessBranch(data.branch_id) || $ac.hasAccessStore(data.store_id)) && (['draft'].includes(data.status_name))))">
                <loading :loading="$loading.get('reservation_detail_create')" variant="light" type="button">
                  <i class="ri-pencil-fill fs-16"></i> {{ $t('basic.btn.edit') }}
                </loading>
              </BButton>

              <BButton type="button" variant="success"
                @click.prevent="accept(data.id)"
                :disabled="$loading.get('reservation_detail_status')"
                v-if="($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_create') && ($ac.hasAccessBranch(data.branch_id) || $ac.hasAccessStore(data.store_id)))) &&
                (['draft'].includes(data.status_name))">
                <loading :loading="$loading.get('reservation_detail_status')" variant="light" type="button">
                  <i class="mdi mdi-check-bold fs-16"></i> {{ $t('reservation.btn.confirm') }}
                </loading>
              </BButton>
              <BButton type="button" variant="success"
                @click.prevent="accept(data.id)"
                :disabled="$loading.get('reservation_detail_status')"
                v-if="($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_create') && ($ac.hasAccessBranch(data.branch_id) || $ac.hasAccessStore(data.store_id)))) &&
                (['pending'].includes(data.status_name))">
                <loading :loading="$loading.get('reservation_detail_status')" variant="light" type="button">
                  <i class="mdi mdi-check-bold fs-16"></i> {{ $t('reservation.btn.accept') }}
                </loading>
              </BButton>
              <BButton type="button" variant="danger"
                @click.prevent="reject(data.id)"
                :disabled="$loading.get('reservation_detail_status')"
                v-if="($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_create') && ($ac.hasAccessBranch(data.branch_id) || $ac.hasAccessStore(data.store_id)))) &&
                (['pending'].includes(data.status_name))">
                <loading :loading="$loading.get('reservation_detail_status')" variant="light" type="button">
                  <i class="mdi mdi-close-thick fs-16"></i> {{ $t('reservation.btn.reject') }}
                </loading>
              </BButton>

              <BButton type="button" variant="info"
                @click.prevent="signin(data.id)"
                :disabled="$loading.get('reservation_detail_status')"
                v-if="($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_create') && ($ac.hasAccessBranch(data.branch_id) || $ac.hasAccessStore(data.store_id)))) &&
                (['approved'].includes(data.status_name))">
                <loading :loading="$loading.get('reservation_detail_status')" variant="light" type="button">
                  <i class="mdi mdi-login fs-16"></i> {{ $t('reservation.btn.signin') }}
                </loading>
              </BButton>
              <BButton type="button" variant="danger"
                @click.prevent="cancel(data.id)"
                :disabled="$loading.get('reservation_detail_status')"
                v-if="($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_create') && ($ac.hasAccessBranch(data.branch_id) || $ac.hasAccessStore(data.store_id)))) &&
                (['approved'].includes(data.status_name))">
                <loading :loading="$loading.get('reservation_detail_status')" variant="light" type="button">
                  <i class="mdi mdi-delete-outline fs-16"></i> {{ $t('reservation.btn.cancel') }}
                </loading>
              </BButton>
              <BButton type="button" variant="dark"
                @click.prevent="signout(data.id)"
                :disabled="$loading.get('reservation_detail_status')"
                v-if="($ac.hasAccess('reservation_full_access') || ($ac.hasAccess('reservation_create') && ($ac.hasAccessBranch(data.branch_id) || $ac.hasAccessStore(data.store_id)))) &&
                (['going'].includes(data.status_name))">
                <loading :loading="$loading.get('reservation_detail_status')" variant="light" type="button">
                  <i class="mdi mdi-logout fs-16"></i> {{ $t('reservation.btn.signout') }}
                </loading>
              </BButton>
            </div>
          </BCardBody>
        </BCard>
      </BCol>
      <BCol xl="9" v-if="($ac.hasAccess('stuff_full_access') || ($ac.hasAccess('stuff_list')))">
        <BCard no-body>
          <BCardBody style="overflow: scroll;">
            <loading :loading="$loading.get('reservation_detail_stuff_create')" variant="dark" type="block">
              <RoomDetailForm :stuff="stuff" :stuff_id="data.stuff_id" :is_readonly="true" :reservation="data" />
            </loading>
          </BCardBody>
        </BCard>
      </BCol>
    </BRow>
  </Layout>
</template>